<template>
    <div class="e-ejercicio">
        <div class="e-ejercicio-descripcion text-xs-left">
            <p class="instruccion mb-2" v-html="lesson.instructions_spanish"></p>
            <p class="ejemplo-bg primary py-3 px-3 radius mt-1 white--text" v-html="lesson.exercise"></p>
        </div>
        <div class="e-ejercicio-ejercicio  pt-0">
            <v-layout  pt-0 row wrap>
                <SubCardColumna 
                v-for="(option, index) in lesson.options"
                :key="`subcard-${index}`"
                :respuesta="option"
                @clicked="respuestaSelected"
                />
            </v-layout>
        </div>
    </div>
</template>

<script>
import SubCardColumna from '../basica/SubCardColumna'

export default {
  name: 'SubCardColumnaFinal',
  components: {
    SubCardColumna
  },
  props: {
    lesson: {
        type: Object,
        default: {
            instructions_spanish: '',
            exercise: '',
            options: [],
            answer: ''
        }
    }
  },
  data () {
    return {
        respuesta: []
    }
  },
  methods: {
    respuestaSelected (values) {
        if(values.selected){
            this.respuesta.push(values.value)
        } else {
            this.respuesta = this.respuesta.filter( value => value !== values.value )
        }
        const respuestaFinal = {
        answer: this.lesson.answer,
        userAnswer: this.respuesta
        }
        this.$emit('clicked', respuestaFinal)
    }
  }
}
</script>